import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lfx-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  pageCount = 0;
  paginationType = PaginationType;

  @Input() collectionSize: number;
  @Input() page = 1;
  @Input() pageSize: number;

  @Output() pageChange = new EventEmitter<number>(true);

  @Input() boundaryLinks = true;
  @Input() directionLinks = true;
  @Input() disabled = false;
  @Input() ellipses = false;
  @Input() maxSize = 5;
  @Input() rotate = false;
  @Input() type: PaginationType = this.paginationType.OffsetLimit;
  @Input() disableNext = false;
  @Input() disablePrev = false;

  constructor() {}

  ngOnInit() {
    this.pageCount = Math.ceil(this.collectionSize / this.pageSize);
  }

  onPageChange(page: number) {
    this.pageChange.emit(page);
  }

  onPrevious() {
    if (!this.disablePrev) {
      this.pageChange.emit(0);
    }
  }

  onNext() {
    if (!this.disableNext) {
      this.pageChange.emit(1);
    }
  }
}

export enum PaginationType {
  CursorBased = 'cursor-based',
  OffsetLimit = 'offset-limit',
}
